import * as React from 'react';
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useAuth } from '../contexts/AuthContext';
import { LandingLayout } from '../components/complex/LandingLayout';

export default function LogoutPage(props) {
    const { logout } = useAuth();

    const navigate = useNavigate();

    React.useEffect(() => {
        logout();
        navigate("/login?next=/");
    }, []);

    return (
        <LandingLayout>
            Logged out.
        </LandingLayout>
    );
}
